import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { DataSourceLoadOptionsBase, PhotoPdaDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';
import { EnvService } from 'src/environments/environment';
import CustomStore from 'devextreme/data/custom_store';
import { LoadOptions } from 'devextreme/data/load_options';
import { PhotosPdaService } from 'src/api/services';

@Component({
  selector: 'app-photo-select',
  templateUrl: './photo-select.component.html',
  styleUrls: ['./photo-select.component.css']
})
export class PhotoSelectComponent implements OnDestroy {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
  @Select(ControlPanelStore.parcId$) parcId$: Observable<number>;

  parcId: number = null;

  @Input() width: number;
  @Input() widthPopUp: number = 250;
  @Input() height: number = 78;
  @Input() disabled: boolean = false;

  @Input() photoIds: number[] = [];
  @Output() photoIdsChange = new EventEmitter<number[]>();

  ColumnName = [];
  public PhotosPdaGridStore: any = {};

  p: Subscription;

  constructor(private envService : EnvService,
    private translate: TranslateService,
    private photospdaService: PhotosPdaService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
      // Instanciate Globalize for DevExtreme components
      this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());

      this.p = this.parcId$.subscribe( x => {
        if(x) {
          this.parcId = x;
        }
      });

      this.translate.get(
        [
          'Parc',
          'Date',
          'Image',
        ]
      ).subscribe(translations => {
        this.ColumnName.push(translations['Parc']);
        this.ColumnName.push(translations['Date']);
        this.ColumnName.push(translations['Image']);
      });

      this.PhotosPdaGridStore = new CustomStore({
        key: 'Id',
        load: (loadOptions: LoadOptions) => {

          const filter = loadOptions.filter;

          const o: DataSourceLoadOptionsBase = {};
          o.Skip = loadOptions.skip;
          o.Take = loadOptions.take;
          o.RequireTotalCount = loadOptions.requireTotalCount;
          o.RequireGroupCount = loadOptions.requireGroupCount;
          o.Sort = loadOptions.sort;
          o.Filter = filter;
          o.TotalSummary = loadOptions.totalSummary;
          o.Group = loadOptions.group;
          o.GroupSummary = loadOptions.groupSummary;
          return this.photospdaService.photoPdaLoadList({ parcId: this.parcId, body: o })
            .toPromise()
            .then(result => {

              console.log("RESULLLT");
              console.log(result);
                //this.onLoaded.emit(result); // Todo check if needed

                return {
                    data: result.data,
                    totalCount: result.totalCount,
                    summary: result.summary,
                    groupCount: result.groupCount
                };
            });
        },
      });
  }

  ngOnDestroy(): void {
    this.p?.unsubscribe();
  }

  updateInfo(event) {
    console.log("updateInfoupdateInfoupdateInfo");
    if(event.currentSelectedRowKeys.length > 0) {
      this.photoIds = event.currentSelectedRowKeys.map(csrk => csrk.Id);
      console.log("this.photoIds");
      console.log(this.photoIds);
      this.photoIdsChange.emit(this.photoIds);
    }
  }

  getUrlPhoto(data: PhotoPdaDto) {
    return data && data.Id != null ? this.envService.apiUrl + PhotosPdaService.PhotoPdaGetPhotoPdaPath.replace('{photoPdaId}', data.Id.toString()) : "";
  }

  getHeight() {
    return { 'height': this.height+'px' };
  }

  getHeightImage() {
    return this.height;
  }

  onOpened() {
    this.dataGrid.instance.clearSelection();

    document.body.childNodes.forEach(element => {
      if(element.nodeType == 1) {
        if((element as HTMLElement).className.includes("dx-dropdowneditor-overlay")) {
          (element.childNodes[0] as HTMLElement).style.width = `${this.widthPopUp}px`;
        }
      }
    });
  }
}
